import styled from 'styled-components';
import { useState } from 'react';
import { CategoryData, RegionData, ThemeData } from '../../quant/quantData';

interface Props {
  onClose: () => void;

  selectedFilters: {
    theme: string[];
    region: string[];
    category: string[];
    date: string;
  };
  setSelectedFilters: React.Dispatch<
    React.SetStateAction<{
      theme: string[];
      region: string[];
      category: string[];
      date: string;
    }>
  >;
}

function FilterModal({ onClose, selectedFilters, setSelectedFilters }: Props) {
  const [tab, setTab] = useState<'theme' | 'region' | 'category'>('theme');

  const tabItems = [
    { name: '퀀트 테마', key: 'theme' },
    { name: '지역', key: 'region' },
    { name: '부동산 유형', key: 'category' },
  ] as const;

  const getOptions = () => {
    switch (tab) {
      case 'theme':
        return ['전체', ...ThemeData.map(({ name }) => name)];
      case 'region':
        return [...RegionData];
      case 'category':
        return CategoryData.map(({ name }) => name);
      default:
        return [];
    }
  };

  const getSelected = () => selectedFilters[tab];

  const setSelected = (values: string[]) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [tab]: values,
    }));
  };

  const handleTagClick = (item: string) => {
    const current = getSelected();
    if (item === '전세우위주' || item === '월세우위주') {
      alert('준비 중인 테마입니다.');
      return;
    }

    const isRegion = tab === 'region';
    const isAll = isRegion ? item === '전국' : item === '전체';

    if (isAll) {
      setSelected([]);
    } else {
      const updated = current.includes(item)
        ? current.filter((i) => i !== item)
        : [
            ...current.filter((i) => (isRegion ? i !== '전국' : i !== '전체')),
            item,
          ];

      setSelected(updated.length === 0 ? [] : updated);
    }
  };

  return (
    <div>
      <ModalOverlay
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClose();
        }}
      >
        <ModalContainer
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <TitleBox>
            <Spacer />
            <Title>필터</Title>
            <img
              src="/assets/images/close/close-dark-gray.svg"
              alt="닫기"
              width={24}
              onClick={onClose}
            />
          </TitleBox>
          <TabBox>
            <TabInner>
              {tabItems.map(({ name, key }) => (
                <TabItem
                  key={key}
                  active={tab === key}
                  onClick={() => {
                    setTab(key);
                  }}
                >
                  {name}
                </TabItem>
              ))}
            </TabInner>
          </TabBox>
          <TabContent>
            <ContentInnter>
              {getOptions().map((item) => (
                <TagButton
                  key={item}
                  isInactive={item === '전세우위주' || item === '월세우위주'}
                  selected={
                    getSelected().length === 0
                      ? tab === 'region'
                        ? item === '전국'
                        : item === '전체'
                      : getSelected().includes(item)
                  }
                  isRegion={tab === 'region'}
                  onClick={() => handleTagClick(item)}
                >
                  {item}
                </TagButton>
              ))}
            </ContentInnter>
            {tab === 'region' && (
              <InfoBox>
                <img
                  src="/assets/images/icon/info-gray.svg"
                  alt="info"
                  width={14}
                  height={14}
                />
                중복선택이 가능합니다.
              </InfoBox>
            )}
          </TabContent>
          <Divider />
          <SelectedTagContainer>
            {getSelected()
              .filter((item) =>
                tab === 'region' ? item !== '전국' : item !== '전체',
              )
              .map((item) => (
                <SelectedTag key={item}>
                  {item}
                  <img
                    src="/assets/images/close/close_blue.svg"
                    alt="close"
                    width={12}
                    height={12}
                    onClick={() =>
                      setSelected(getSelected().filter((i) => i !== item))
                    }
                  />
                </SelectedTag>
              ))}
          </SelectedTagContainer>
          <ButtonBox>
            <CancleButton onClick={() => setSelected([])}>초기화</CancleButton>
            <SubmitButton onClick={onClose}>적용</SubmitButton>
          </ButtonBox>
        </ModalContainer>
      </ModalOverlay>
    </div>
  );
}

export default FilterModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px -4px 15px 0px #00000040;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px;

  img {
    cursor: pointer;
  }
`;
const Spacer = styled.div`
  width: 24px;
`;

const Title = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const TabBox = styled.div`
  padding-right: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
`;

const TabInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: flex-start;
  align-items: center;
  border-right: none;
  border-bottom: 1px solid #e5e8ea;
`;

const TabItem = styled.div<{ active: boolean }>`
  padding: 8px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: ${(props) => (props.active ? '#222' : '#989BA2')};
  border-bottom: ${(props) => (props.active ? '2px solid #222' : 'none')};
`;

const TabContent = styled.div`
  height: 280px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ContentInnter = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 24px;
`;

const TagButton = styled.button<{
  selected?: boolean;
  isInactive?: boolean;
  isRegion?: boolean;
}>`
  padding: 7px 12px;
  border-radius: 8px;
  background-color: ${({ selected, isInactive }) =>
    isInactive ? '#F2F2F2' : selected ? '#EAF2FE' : '#70737C14'};
  border: none;
  cursor: pointer;

  font-size: 14px;
  font-weight: 500;
  color: ${({ selected, isInactive }) =>
    isInactive ? '#B0B0B0' : selected ? '#008AFF' : '#616161'};

  ${({ isRegion }) =>
    isRegion &&
    `
    width: calc((100% - 24px) / 4);
    text-align: center;
  `}
`;

const Divider = styled.div<{ selected?: boolean }>`
  width: 100%;
  height: 1px;
  background-color: #e5e8ea;
`;

const SelectedTagContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  padding: 16px;
  gap: 8px;
`;

const SelectedTag = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  border-radius: 9999px;
  padding: 4px 5px;
  align-items: center;
  background-color: #eaf2fe;
  white-space: nowrap;

  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #008aff;

  img {
    cursor: pointer;
  }
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px 24px;
`;

const CancleButton = styled.button`
  padding: 12px 28px;
  border-radius: 8px;
  background-color: #70737c14;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;

  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
`;

const SubmitButton = styled(CancleButton)`
  flex: 1;
  text-align: center;
  padding: 12px 24px;
  border-radius: 8px;
  background-color: #008aff;
  cursor: pointer;

  color: #ffffff;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding-bottom: 16px;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #37383c9c;
`;
